import React, { useEffect, useState, useContext, useCallback } from "react";
import jMoment from "moment-jalaali";

import Input from "../../shared/components/Input";
import {
  VALIDATOR_REQUIRE,
  VALIDATOR_VALIDATED,
  VALIDATOR_AUTOCOMPLETE,
  VALIDATOR_DATE,
  VALIDATOR_NUMBER_ONLY,
} from "../../shared/util/validators";
import useForm from "../../shared/hooks/form-hooks";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Unstable_Grid2";
import uuid from "react-uuid";
import EndTable from "../components/EndTable";
import { TextField } from "@mui/material";
import { AuthContext } from "../../context/AuthContext";
import { baseUrl } from "../../baseUrl";
import { addCommas } from "@persian-tools/persian-tools";

const ReceiptSubmission = (props) => {
  const orders = useSelector((state) => state.ReceiptReducer.orders);
  const dispatch = useDispatch();
  let valueSum = 0;
  orders.forEach((order) => {
    valueSum += order.afterDiscount;
    order.details.forEach((detail) => (valueSum += detail.discountPrice));
  });

  const auth = useContext(AuthContext);
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(true);
  const [formState, inputHandler, setFormData] = useForm(
    {
      name: {
        value: "",
        isValid: false,
      },
      submitDate: {
        value: "",
        isvalid: true,
      },
      receiptId: {
        value: "",
        isValid: false,
      },
      endDiscount: {
        value: "",
        isValid: false,
      },
      accountNumber: {
        value: "",
        isValid: false,
      },
      description: {
        value: "",
        isvalid: true,
      },
      doctorName: {
        value: "",
        isValid: true,
      },
      laboratoryId: {
        value: "",
        isValid: true,
      },
    },
    false
  );
  useEffect(() => {
    setFormData(
      {
        name: {
          value: "",
          isValid: true,
        },
        submitDate: {
          value: jMoment(),
          isvalid: true,
        },
        receiptId: {
          value: uuid(),
          isValid: true,
        },
        totalReceipt: {
          value: valueSum,
          isValid: true,
        },
        totalDiscount: {
          value: 0,
          isValid: true,
        },
        accountNumber: {
          value: "6274-1211-7264-4155",
          isValid: true,
        },
        endDiscount: {
          value: 0,
          isValid: true,
        },
        description: {
          value: "",
          isvalid: true,
        },
        doctorName: {
          value: "",
          isValid: true,
        },
        laboratoryId: {
          value: "",
          isValid: true,
        },
      },
      true
    );
    setIsLoading(false);
  }, [setFormData, orders, valueSum]);

  const ACCOUNTS = ["6274-1211-7264-4155", "4155-4565-7874-4215"];
  const [endPrice, setEndPrice] = useState(
    valueSum - Number(formState.inputs.endDiscount.value)
  );

  // get doctors name
  const [doctorNames, setDoctorNames] = useState([]);
  const getDoctorsNames = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await fetch(
        baseUrl + `/api/v1/laboratorys/get-doctors`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: auth.token,
          },
          body: JSON.stringify({
            onlyName: true,
            page: 1,
          }),
        }
      );
      if (response.ok) {
        const responseData = await response.json();
        setDoctorNames(
          responseData.data.result.map((item) => {
            return { name: item.name, id: item.id };
          })
        );
      } else {
        throw new Error(response.message);
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      err &&
        err.data.map((error) => enqueueSnackbar(error, { variant: "error" }));
    }
  }, [auth.token, enqueueSnackbar]);

  useEffect(() => {
    getDoctorsNames();
  }, [getDoctorsNames]);

  useEffect(() => {
    dispatch({
      type: "addInfo",
      payload: {
        receiptId: formState.inputs.receiptId.value,
        submitDate: formState.inputs.submitDate.value,
        name: formState.inputs.name.value,
        accountNumber: formState.inputs.accountNumber.value,
        description: formState.inputs.description.value,
        totalPrice: endPrice,
        doctorLabId: formState.inputs.doctorName.value.id,
        discountPrice: Number(formState.inputs.endDiscount.value),
        laboratoryId: formState.inputs.laboratoryId.value,
      },
    });
  }, [formState, endPrice, dispatch]);

  useEffect(() => {
    setEndPrice(valueSum - Number(formState.inputs.endDiscount.value));
    props.setDoctorName(formState.inputs.doctorName.value.name);
    console.log(formState.inputs.doctorName.value.name);
  }, [
    formState.inputs.doctorName.value,
    formState.inputs.endDiscount.value,
    props,
    valueSum,
  ]);
  if (isLoading) {
    return (
      <div className="center">
        <h2>در حال بارگذاری</h2>
      </div>
    );
  }

  return (
    <form>
      <Paper sx={{ p: 2, m: 1 }} elevation={2}>
        <Grid container spacing={2}>
          <Grid md={4} xs={12}>
            <Input
              id="name"
              element="input"
              label="به نام"
              validators={[VALIDATOR_REQUIRE()]}
              errorText="ارگان یا شخص مربوطه را وارد کنید."
              onInput={inputHandler}
            />
          </Grid>
          <Grid md={4} xs={12}>
            <Input
              id="doctorName"
              element="autoComplete"
              label="نام پزشک"
              validators={[VALIDATOR_AUTOCOMPLETE()]}
              errorText="لطفا نام دکتر را انتخاب کنید."
              onInput={inputHandler}
              options={doctorNames}
              getOptionLabel={(option) => option.name}
              initialValue={formState.inputs.doctorName.value}
              inputValid={formState.inputs.doctorName.isValid}
            />
          </Grid>
          <Grid md={4} xs={12}>
            <Input
              id="submitDate"
              element="datePick"
              label="تاریخ صدور"
              validators={[VALIDATOR_DATE()]}
              inputValid={formState.inputs.submitDate.isValid}
              initialValue={formState.inputs.submitDate.value}
              onInput={inputHandler}
              disabled={true}
            />
          </Grid>
        </Grid>
        <Grid xs={12}>
          <EndTable orders={orders} />
        </Grid>
        <Grid container spacing={2}>
          <Grid md={6} xs={12}>
            <Input
              id="endDiscount"
              element="number_only"
              label="تخفیف"
              onInput={inputHandler}
              validators={[VALIDATOR_VALIDATED(), VALIDATOR_NUMBER_ONLY()]}
              type="text"
              errorText="مقدار تخفیف را به درستی وارد کنید"
              inputProps={{ min: 0 }}
              needsThousandSeparator
            />
          </Grid>
          <Grid md={6} xs={12}>
            <TextField
              id="endPrice"
              label="مبلغ نهایی"
              value={addCommas(endPrice)}
              fullWidth
              variant="standard"
              inputProps={{ readOnly: true }}
            />
          </Grid>

          <Grid md={12} xs={12}>
            <Input
              id="accountNumber"
              element="textfield"
              label="شماره حساب"
              validators={[VALIDATOR_REQUIRE()]}
              errorText="لطفا شماره حساب را انتخاب کنید."
              initialValue={formState.inputs.accountNumber.value}
              inputValid={formState.inputs.accountNumber.isValid}
              onInput={inputHandler}
              options={ACCOUNTS}
              required={true}
            />
          </Grid>
          <Grid md={12} xs={12}>
            <Input
              id="description"
              element="input"
              label="توضیحات"
              validators={[VALIDATOR_VALIDATED()]}
              onInput={inputHandler}
              multiline={true}
            />
          </Grid>
        </Grid>
      </Paper>
    </form>
  );
};
export default ReceiptSubmission;
